import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'no-access-layout',
  templateUrl: './no-access-layout.component.html',
  styleUrls: ['./no-access-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NoAccessLayoutComponent {}
